import React from 'react';
import './Process.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Process = () => {
  const sectionRef = useScrollAnimation();
  const processSteps = [
    {
      step: '01',
      title: 'Initial Consultation',
      description: 'We start with a comprehensive consultation to understand your specific accounting needs and financial situation.',
      icon: '💬'
    },
    {
      step: '02',
      title: 'Document Collection',
      description: 'We guide you through collecting all necessary documents and financial records for your case.',
      icon: '📄'
    },
    {
      step: '03',
      title: 'Expert Preparation',
      description: 'Our certified accountants prepare your taxes or handle your accounting with meticulous attention to detail.',
      icon: '⚙️'
    },
    {
      step: '04',
      title: 'Compliance Review',
      description: 'We thoroughly review everything to ensure full compliance with Canadian tax regulations.',
      icon: '✅'
    },
    {
      step: '05',
      title: 'Timely Filing',
      description: 'We handle all filing and submission processes, ensuring you meet all deadlines.',
      icon: '📤'
    },
    {
      step: '06',
      title: 'Ongoing Support',
      description: 'We provide continuous support and guidance for all your future accounting needs.',
      icon: '🤝'
    }
  ];

  const painPoints = [
    {
      problem: "Tax deadlines are overwhelming and easy to miss.",
      solution: "We ensure timely filings, so you never have to worry about penalties or late fees."
    },
    {
      problem: "I'm not sure if I'm maximizing my tax deductions.",
      solution: "Our experts find every deduction and credit you're entitled to, saving you money."
    },
    {
      problem: "Keeping up with financial records takes too much time.",
      solution: "Our bookkeeping services keep your financials organized and compliant, giving you back valuable time."
    },
    {
      problem: "I don't know how to plan for my business's future.",
      solution: "With forecasting and budgeting services, we provide a roadmap for your business growth."
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="process" className="process section fade-in-left" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">How We Work</h2>
          <p className="section-subtitle">Our proven process ensures accuracy, compliance, and peace of mind</p>
        </div>

        <div className="process-steps">
          {processSteps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="step-number">{step.step}</div>
              <div className="step-content">
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="pain-points-section">
          <h3>We Understand Your Pain Points!</h3>
          <p>Schedule a free consultation today.</p>
          
          <div className="pain-points-grid">
            {painPoints.map((point, index) => (
              <div key={index} className="pain-point-card">
                <div className="problem">
                  <p>"{point.problem}"</p>
                </div>
                <div className="solution">
                  <p>{point.solution}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="simplify-section">
          <h3>We Simplify Your Taxes and Finances</h3>
          <p>Managing your taxes and finances doesn't have to be stressful. We're here to handle the details so you can focus on what matters most—your life and business.</p>
          
          <button 
            onClick={() => scrollToSection('contact')} 
            className="btn btn-primary"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default Process;
